import { render, staticRenderFns } from "./nodalPaymentsTransfer.vue?vue&type=template&id=1c667637"
import script from "./nodalPaymentsTransfer.vue?vue&type=script&lang=js"
export * from "./nodalPaymentsTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports